import { render, staticRenderFns } from "./ModalMCTotal.vue?vue&type=template&id=584ad00a&"
import script from "./ModalMCTotal.vue?vue&type=script&lang=js&"
export * from "./ModalMCTotal.vue?vue&type=script&lang=js&"
import style0 from "./ModalMCTotal.vue?vue&type=style&index=0&id=584ad00a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports